"use client";
import { useTenant } from "@/lib/tenant/context";
import { getTenantData } from "@osn/helpers";
import { MainAppLayoutContext } from "@osn/react-components";
import { usePathname } from "next/navigation";
import { unloggedItems } from "./navigation";
import { PortalNavigationProvider } from "./PortalNavigationProvider";

function MainAppLayoutProvider({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const tenant = useTenant();

  if (pathname.startsWith("/login/capacitor")) return children;

  if (pathname === "/register") {
    return (
      <MainAppLayoutContext.Provider
        value={{
          navigation: unloggedItems,
          appName: "Participants Portal",
          tenantData: getTenantData(tenant.name, tenant.displayName),
        }}
      >
        {children}
      </MainAppLayoutContext.Provider>
    );
  }

  return <PortalNavigationProvider>{children}</PortalNavigationProvider>;
}

export { MainAppLayoutContext, MainAppLayoutProvider };
